package com.appsyde.shared.modules.ai.domain.usecase

import com.appsyde.shared.modules.ai.domain.model.AiExtractV2
import com.appsyde.shared.modules.ai.domain.repository.AiRepositoryV2
import kotlinx.serialization.json.Json

class RegenerateContextUseCase(
    private val repo: AiRepositoryV2,
) {
    private val json = Json { ignoreUnknownKeys = true }

    suspend operator fun invoke(messageId: String): AiExtractV2 {
        val raw = repo.regenerateContextJson(messageId = messageId)
        return runCatching {
            json.decodeFromString(AiExtractV2.serializer(), raw)
        }.getOrElse { _ -> AiExtractV2() }
    }
}
